module.exports = __webpack_public_path__ + "static/media/23.a5466412.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/23.svg
// module id = 141
// module chunks = 0